import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchState } from '../../services/search.state';

@Component({
	selector: 'app-search-bar',
	templateUrl: './search-bar.component.html',
	styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnChanges, OnDestroy {
	@Input() public tableName: string;
	public inputValue: string = null;
	private inputValueSubscription: Subscription;

	public constructor(private searchState: SearchState) {}

	public ngOnChanges(): void {
		this.inputValueSubscription = this.searchState
			.get(this.tableName)
			.subscribe((searchKeywords: string | null) => (this.inputValue = searchKeywords));
	}

	public searchChanged(e: any): void {
		this.searchState.set(this.tableName, e.detail.value);
	}

	public cancelSearch(): void {
		this.searchState.set(this.tableName, null);
	}

	public ngOnDestroy() {
		this.inputValueSubscription.unsubscribe();
	}
}
